export interface Channel {
  id: string;
  name: string;
  limit?: number;
  images?: string[];
  selected?: boolean;
}
